import React from 'react';
import { TaskDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import TaskDrillDownTableRow from '../TaskDrillDownTableRow/TaskDrillDownTableRow';

type TaskDrillDownTableBodyProps = {
  items: Array<TaskDrillDownItem>;
};

const TaskDrillDownTableBody: React.FC<TaskDrillDownTableBodyProps> = ({
  items,
}) => {
  return (
    <tbody>
      {items.map((item) => (
        <TaskDrillDownTableRow key={item.id} item={item} />
      ))}
    </tbody>
  );
};

export default TaskDrillDownTableBody;
